<script lang="ts" setup>
import { watch, onMounted, ref } from 'vue'
import type { PropType } from 'vue'
import { icons } from 'feather-icons'
import type { FeatherIconNames } from 'feather-icons'

const props = defineProps({
  type: {
    type: String as PropType<FeatherIconNames>,
    default: 'help-circle'
  },
  size: {
    type: String,
    default: 'base',
    validator: (value: string) =>
      ['xs', 'sm', 'base', 'lg', 'xl', '2xl'].includes(value)
  }
})

const wrapper = ref<HTMLElement | null>(null)

const updateIcon = () => {
  const rootElement = document.querySelector(':root')
  if (!rootElement) return
  const rootStyles = getComputedStyle(rootElement)
  const rootSize = parseInt(rootStyles.fontSize)
  const baseSize = rootSize + (parseInt(rootStyles.lineHeight) - rootSize) / 2
  const icon = icons[props.type]
  if (icon) {
    let pixelSize
    switch (props.size) {
      case 'xs':
        pixelSize = 0.75 * baseSize
        break
      case 'sm':
        pixelSize = 0.875 * baseSize
        break
      case 'base':
        pixelSize = baseSize
        break
      case 'lg':
        pixelSize = 1.125 * baseSize
        break
      case 'xl':
        pixelSize = 1.25 * baseSize
        break
      case '2xl':
        pixelSize = 1.5 * baseSize
        break
      default:
        pixelSize = baseSize
        break
    }
    const options = {
      width: Math.floor(pixelSize),
      height: Math.floor(pixelSize)
    }

    if (wrapper.value) {
      wrapper.value.innerHTML = icon.toSvg(options)
    }
  }
}

watch(
  () => props.type,
  () => updateIcon()
)

onMounted(() => updateIcon())
</script>

<template>
  <i ref="wrapper" :data-icon="type" class="inline-block" />
</template>
